module.exports = __webpack_public_path__ + "img/4w2.ac3da48d.jpg";